import React, { useEffect } from "react";
import { Route, Switch, Redirect } from "react-router";
import Layout from "../components/Layout";
import Home from "../components/Home";

import QuotePage from "../features/quotePage/QuotePage";
import QuotesPage from "../features/quotesList/QuotesPage";

import "react-toastify/dist/ReactToastify.css";

import { MyQuotesPage } from "../features/myQuotesPage/MyQuotesPage";
import { FinancePage } from "../features/staticPages/FinancePage";
import { ProtectPage } from "../features/staticPages/ProtectPage";
import { PrivacyPage } from "../features/staticPages/PrivacyPage";
import { TermsPage } from "../features/staticPages/TermsPage";
import { EditQuotePage } from "../features/editQuotePage/EditQuotePage";
import { ReviewsPage } from "../features/staticPages/ReviewsPage";
import { IconsPage } from "../features/staticPages/IconsPage";
import { toast } from "react-toastify";
import { RedirectPage } from "../features/redirectPage/RedirectPage";
import { CovidPage } from "../features/staticPages/CovidPage";
import { PaymentPage as StaticPaymentPage } from "../features/staticPages/PaymentPage";
import { FeatureConfigGtmContainerId, FeatureGtm, PermissionQuoteRead } from "./consts";
import QuoteAddonWizardPage from "../features/quoteAddonWizardPage/QuoteAddonWizardPage";
import QuoteCartPage from "../features/quoteCartPage/QuoteCartPage";
import { TestPage } from "../features/staticPages/TestPage";
import { CheckoutPage } from "../features/checkoutPage/CheckoutPage";
import { CheckoutSuccessPage } from "../features/checkoutSuccessPage/CheckoutSuccessPage";
import { QuoteDetailPage } from "../features/quoteDetailPage/QuoteDetailPage";

import { useAuth, PrivateRoute, Loader, NotFound, SignedOutPage } from "swyft-react-core";
import { OutcomePage } from "../features/quoteDetailPage/OutcomePage";
import { gtm } from "../components/config/gtm";
import { useConfig } from "../components/config/ConfigContext";

import { PaymentPage } from "../features/paymentPage/PaymentPage";

// const gtmId = "GTM-5ND2P9W"; // Prod
// const gtmId = "GTM-55VQQLVB"; // Dev

const App = () => {
  toast.configure();

  const { isLoading, error } = useAuth();
  const { getFeatureConfigValue } = useConfig();

  useEffect(() => {
    gtm.initialize({
      containerId: getFeatureConfigValue(FeatureGtm, FeatureConfigGtmContainerId) ?? "GTM-55VQQLVB"
    });
  }, [getFeatureConfigValue]);

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    console.log("AuthState - Error", error.message);
    return <div>Auth Error - Contact Support</div>;
  }

  return (
    <Switch>
      <Route
        exact
        path="/signout-redirect"
        component={() => <SignedOutPage name="Swyft Store" redirectPath="/quotes" />}
      />
      <Layout>
        <Switch>
          <Redirect from="/signin-redirect" to="/quotes" />
          <Route exact path="/" component={Home} />
          <Route exact path="/quote-v1/:id" component={QuotePage} />
          <Route exact path="/quote/addon/:id" component={QuoteAddonWizardPage} />
          <Route exact path="/quote/cart/:id" component={QuoteCartPage} />
          <Route exact path="/my-quotes" component={MyQuotesPage} />
          <Route exact path="/finance" component={FinancePage} />
          <Route exact path="/protect" component={ProtectPage} />
          <Route exact path="/terms" component={TermsPage} />
          <Route exact path="/privacy" component={PrivacyPage} />
          <Route exact path="/reviews" component={ReviewsPage} />
          <Route exact path="/icons" component={IconsPage} />
          <Route exact path="/test" component={TestPage} />
          <Route exact path="/redirect" component={RedirectPage} />
          <PrivateRoute permission={PermissionQuoteRead} exact path="/quote/edit/:id" component={EditQuotePage} />
          <PrivateRoute permission={PermissionQuoteRead} exact path="/quotes" component={QuotesPage} />
          <Route exact path="/covid19" component={CovidPage} />
          <Route exact path="/payment" component={StaticPaymentPage} />
          {/*<-- newDesign */}
          <Route exact path="/checkout/:id" component={CheckoutPage} />
          <Route exact path="/payment/:id" component={PaymentPage} />
          <Route exact path="/checkout-success/:id" component={CheckoutSuccessPage} />
          
          <Route exact path="/quote/:id" component={QuoteDetailPage} />
          <Route exact path="/outcome/:id" component={OutcomePage} />
          {/* newDesign -->*/}
          <Route component={NotFound} />
        </Switch>
      </Layout>
    </Switch>
  );
};

export default App;
